import React, { Component } from "react";
// import { connect } from 'react-redux';
// import { getConsoleUserLoginHistory } from '../../actions/userLogActions';
import { Form, Col, Row, Button, Table } from "react-bootstrap";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
// import Moment from 'react-moment';
// import { getConsoleUserByNameOrNumber } from '../../actions/userLogActions';
// import Pagination from '../subLevel/Pagination';
import "../../assets/styles/RetailPortalCouponsList.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";
import AddNumberCSVModal from "../modals/AddNumberCSVModal";
import RetailPortalCreateNewCoupons from "./RetailPortalCreateNewCoupons";
import DiscountCouponUserList from "../DiscountCoupons/RetailCouponUserList";
import CsvDownloader from "react-csv-downloader";

class RetailPortalCouponsList extends Component {
  constructor() {
    super();
    this.state = {
      retailPortalCoupons: [],
      showListComponent: true,
      showCouponUserList: false,
      users: [],
    };
  }

  async componentDidMount() {
    let retailPortalCoupons = await this.getRetailPortalCouponsByRetailPortalId();
    this.setState({
      ...this.state,
      retailPortalCoupons,
    });
  }

  getRetailPortalCouponsByRetailPortalId = async () => {
    const portal_id = this.props.match.params.id;
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    return sess_get("admin/console/retail-portal/coupons", session_token, {
      portal_id,
    })
      .then((response) => {
        return response.data.response;
      })
      .catch((error) => {
        // console.log(error);
        return [];
      });
  };

  handleModalClose = () => {
    this.setState({ addNumberCSVModal: null });
  };

  redirectToCoupon = (id) => {
    return () => {
      this.props.history.push("/retail/" + id);
    };
  };

  showCouponUserList = (users) => {
    const { showCouponUserList } = this.state;
    this.setState({ showCouponUserList: !showCouponUserList, users });
  };

  render() {
    const { showListComponent, retailPortalCoupons } = this.state;
    let columns = [];
    if (retailPortalCoupons.length) {
      // columns = Object.keys(retailPortalCoupons[0]).map((key) => ({
      //   id: key,
      //   displayName: key,
      // }));
      columns = [
        { id: "code", displayName: "Code" },
        { id: "createdAt", displayName: "Created At" },
        { id: "plans", displayName: "Plans" },
        { id: "flat", displayName: "Flat Discount" },
        { id: "percentage", displayName: "Discount Percentage" },
        { id: "percentageCap", displayName: "Percentage Cap" },
        { id: "limit", displayName: "Limit" },
        { id: "used", displayName: "IsUsed" },
        { id: "usedAt", displayName: "Used At" },
        { id: "startDate", displayName: "Start Date" },
        { id: "expiryDate", displayName: "Expiry Date" },
        { id: "active", displayName: "Active" },
      ];
    }
    const { showCouponUserList, users } = this.state;
    return (
      <div>
        {showCouponUserList && (
          <DiscountCouponUserList
            users={users}
            showCouponUserList={this.showCouponUserList}
          />
        )}
        {showListComponent && !showCouponUserList && (
          <div className="retail-store-list-container">
            <div className="table-header">
              <div>Retail Store Coupons</div>
              <div>
                <button
                  onClick={() => {
                    this.props.history.goBack();
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                {retailPortalCoupons.length && (
                  <CsvDownloader
                    filename="coupons"
                    separator=","
                    columns={columns}
                    datas={this.state.retailPortalCoupons.map((coupon) => {
                      return {
                        ...coupon,
                        updatedAt: formatDate(coupon.updatedAt),
                        createdAt: formatDate(coupon.createdAt),
                        startDate: formatDate(coupon.startDate),
                        usedAt: formatDate(coupon.usedAt),
                        expiryDate: formatDate(coupon.expiryDate),
                      };
                    })}
                    text="DOWNLOAD"
                  />
                )}
                <button
                  className={"add-button"}
                  onClick={() => {
                    this.setState({
                      showListComponent: !this.state.showListComponent,
                    });
                  }}
                >
                  +
                </button>
              </div>
            </div>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Code</th>
                  <th>Created At</th>
                  <th>Plan</th>
                  <th>Flat Discount</th>
                  <th>Discount Percentage</th>
                  <th>Percentage Cap</th>
                  {/* <th>Usage Limit</th> */}
                  <th>Limit</th>
                  <th>IsUsed</th>
                  <th>Used At</th>
                  <th>Start Date</th>
                  <th>Expiry Date</th>
                  <th>Coupon User</th>
                  <th>Active</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {this.state.retailPortalCoupons.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.code}</td>
                      <td>{item.createdAt.split("T")[0]}</td>
                      <td>{item.plans}</td>
                      <td>{item.flat}</td>
                      <td>{item.percentage}</td>
                      <td>{item.percentageCap}</td>
                      <td>
                        <div>{item.limit || "-"}</div>
                      </td>
                      <td>{item.used ? "True" : "False"}</td>
                      <td>{item.usedAt.split("T")[0]}</td>
                      <td>{item.startDate.split("T")[0]}</td>
                      <td>{item.expiryDate.split("T")[0]}</td>
                      <td
                        className="edit"
                        onClick={() => {
                          this.showCouponUserList(item.users);
                        }}
                      >
                        <a className={"edit-button"}>
                          {item.users.length ? "Users" : "-"}
                        </a>
                      </td>
                      <td>{item.active ? "True" : "False"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <AddNumberCSVModal
              id={this.state.addNumberCSVModal}
              show={this.state.addNumberCSVModal ? true : false}
              close={this.handleModalClose}
            />
          </div>
        )}
        {!showListComponent && (
          <RetailPortalCreateNewCoupons store_id={this.props.match.params.id} />
        )}
      </div>
    );
  }
}

function formatDate(date) {
  if (date === "-") return date;
  date = new Date(date);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
}

export default withRouter(RetailPortalCouponsList);
